import { render } from "./SolicitudesEnProceso.vue?vue&type=template&id=11a218f8&scoped=true"
import script from "./SolicitudesEnProceso.vue?vue&type=script&lang=js"
export * from "./SolicitudesEnProceso.vue?vue&type=script&lang=js"

import "./SolicitudesEnProceso.vue?vue&type=style&index=0&id=11a218f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a218f8"]])

export default __exports__